//
//
//
//
//
//
//
//
//
//
//
//
//

import ChartjsComponentRadarChart from './charts-components/ChartjsComponentRadarChart.vue'
import chartjsData from './chartjsData'

export default {
  components: {
    ChartjsComponentRadarChart,
  },
  setup() {
    return {
      chartjsData,
    }
  },
}
